import { Link } from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { type Route } from './+types/forgot-username.ts'

export const meta: Route.MetaFunction = () => {
	return [{ title: 'Username Recovery for Clearwater Farms 1' }]
}

export default function UsernameEamiledRoute() {
	return (
		<div className="container pb-32 pt-20">
			<div className="flex flex-col justify-center">
				<div className="text-center">
					<h1 className="text-h1">Email Sent</h1>
					<p className="mt-3 text-body-md text-muted-foreground">
						We've sent you an email with your username.
					</p>

					<p className="mt-3 text-body-sm text-muted-foreground">
						Please check your email and if you don't see it perhaps look in your
						Junk folder.
					</p>
				</div>
				<div className="mx-auto mt-16 min-w-full max-w-sm sm:min-w-[368px]">
					<Button asChild variant="outline" className="">
						<Link
							to="/login"
							className="mt-2 text-center text-body-sm font-bold"
						>
							<Icon name="arrow-left" className="mr-2" />
							Back to Login
						</Link>
					</Button>
				</div>
			</div>
		</div>
	)
}
